const locales = new Map<string, string>([
  ['pt', 'pt-PT'],
  ['en', 'en-US'],
]);

export function toDecimal(value: number, places = 2): number {
  return Number(Math.round(parseFloat(value + 'e' + places)) + 'e-' + places);
}

export function toCurrency(
  value?: number | string | null,
  { locale, currency }: { currency?: string; locale?: string } = { currency: 'EUR', locale: 'pt' },
) {
  const finalValue = value ?? 0;
  const localeToUse = locale ? locales.get(locale) || locales.get('pt') : locales.get('pt');
  const currencyToUse = currency || 'EUR';
  return Number(finalValue).toLocaleString(localeToUse, { currency: currencyToUse, style: 'currency' });
}

export function toPercent(value?: number | string | null, { locale }: { locale: string } = { locale: 'pt' }) {
  const finalValue = value ?? 0;
  const localeToUse = locales.get(locale) || locales.get('pt');
  return Number(finalValue).toLocaleString(localeToUse, { style: 'percent', maximumFractionDigits: 2 });
}

export function parseCurrencyString(value: string): number {
  // Remove the currency symbol and any whitespace
  const cleanString = value.replace(/[^\d,.-]/g, '');
  // Replace the thousands separator '.' with an empty string
  const noThousandsSeparator = cleanString.replace(/\./g, '');
  // Replace the decimal separator ',' with '.'
  const standardizedString = noThousandsSeparator.replace(/,/g, '.');
  // Convert the resulting string to a number
  return parseFloat(standardizedString);
}

export function toNumberOrDefault(value: unknown, defaultValue: number = 0): number {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  if (typeof value === 'number') {
    return value;
  }

  const converted = Number(value);
  if (Number.isNaN(converted)) {
    return defaultValue;
  }

  return converted;
}

export function safeFormat(value: unknown, formatter: Intl.NumberFormat): string {
  const numericValue = typeof value === 'number' ? value : Number(value);

  return Number.isFinite(numericValue) ? formatter.format(numericValue) : String(value);
}
